import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 5
const slug = 'bulk-soil-removal-and-rock-breaking-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Bulk Soil Removal & Rock Breaking Sydney | ${BUSINESS_NAME}`,
        description: "Efficient bulk excavation, soil removal, and rock breaking services for major construction and development projects.",
        keywords: "bulk soil removal sydney, rock breaking sydney, excavation services, earthmoving, soil disposal, site preparation, heavy machinery, construction site management, residential soil removal, commercial soil removal, land clearing, foundation preparation, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Bulk Soil Removal & Rock Breaking',
    description: 'Efficient bulk excavation, soil removal, and rock breaking services for major construction and development projects.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
